import { Alert, Stack } from "@mui/material";
import { ProjectDto } from "../../../api/psc";
import {
    CardInformation,
    DialogContainer,
    DialogHeader,
} from "../../../components/exports";
import ProjectDetailSms from "../../project-detail/Shared/ProjectDetailSms";

export default function SmsCampaignFromProjectSelectionDialog(props: {
    projects: ProjectDto[];
    onSent: () => void;
}) {
    return (
        <DialogContainer preferredWith={450}>
            <DialogHeader title="ارسال پیامک به پروژه های منتخب" />

            <Stack spacing={2} sx={{ p: 2 }}>
                {props.projects.some((p) => !p.canVisit) && (
                    <Alert severity="warning">
                        امکان ارسال پیامک به برخی از پروژه های انتخاب شده وجود
                        ندارد
                    </Alert>
                )}

                <CardInformation
                    title="تعداد پروژه های انتخاب شده"
                    value={`${props.projects.length} عدد`}
                />

                <ProjectDetailSms
                    projects={props.projects}
                    onSent={props.onSent}
                />
            </Stack>
        </DialogContainer>
    );
}
